<template>
	<div class="page-wrapper">
		<div class="page full-page d-flex align-items-center">
			<div class="container">
				<div class="row">
					<div class="col-md-6 text-center">
						<img src="/images/404-ostock.png" alt="404">
					</div>
					<div class="col-md-6 d-flex align-items-center">
						<div class="not-found-content">
							<div class="not-found-title">Oh no, Sorry we don't have the page you were looking for.</div>
							<div class="not-found-description">
								Go back to the <router-link to="/">Dashboard</router-link>.
							</div>
							<!-- <div class="not-found-description">
								Have a question? Head over to our <a href="https://help.ostock.id"
									target="_blank">knowledgebase</a>, or submit your question to our <a
									href="https://support.ostock.id" target="_blank">support system</a>. Or go back to the
								<router-link to="/">Dashboard</router-link>.
							</div> -->
						</div>
					</div>
				</div>
			</div>
		</div>
		<main-footer></main-footer>

	</div>
</template>

<script>
import MainFooter from '@/components/homepages/Footer.vue';

export default {
	name: 'pageNotFound',
	components: {
		MainFooter,
	},
	data() {
		return {
		};
	},
	created() {
		document.body.classList.add('not-found');
	},
	destroyed() {
		document.body.classList.remove('not-found');
	},
};
</script>

<style scoped>
.full-page {
	height: calc(100vh - 62px);
}
</style>
